import PartEx from "./part-ex";
import PartExchange from "./part-exchange";
import './scss/index.scss';

export default class ValueYourCarView {
    constructor(parent) {
        this.parent = parent;
        this.el = parent.el.querySelector('.value-your-car-view');

        this.partEx = new PartEx(this);
        this.partExchange = new PartExchange(this);
    }

    show() {
        this.el.classList.remove('hide');
    }

    hide() {
        this.el.classList.add('hide');
    }
}
